module.exports = __webpack_public_path__ + "static/media/payment-img.bc90395d.svg";